<div class="container">
  @if (noFaresFound()) {
    <div class="messagesdiv messagesdiv_warning mt-2">
      <ul>
        <li class="firstchild alert">
          <i class="fa fa-exclamation-circle"></i>
        </li>

        <li class="secondchild pt-2">
          <h3>{{ errorMessageText() }}</h3>
        </li>
      </ul>

      <hr />
    </div>
  }

  @if (!noFaresFound()) {
    <div class="modal-content mt-2">
      <div class="modal-body">
        @if (!reshowSpinner()) {
          <div class="text-center">
            <div class="spinner-border text-info m-5" role="status"></div>
          </div>
        }

        @for (psgr of refareRuleRes(); track $index; let i = $index) {
          <div class="modal-area">
            <div class="tab-content">
              <div class="tab-pane active" #farelabels [id]="'home_' + i" role="tabpanel">
                <table width="100%" cellspacing="0" cellpadding="0" class="customtable">
                  <tr>
                    <th>Fare Rule Name</th>
                    <th>Description</th>
                  </tr>

                  @for (desc of psgr.description; track $index) {
                    <tr>
                      <td>
                        {{ desc.name }}
                      </td>

                      <td>
                        @if (psgr.name === "Terms and Conditions") {
                          <a class="active" target="_blank" [href]="desc.description">
                            @if (desc?.description?.length) {
                              <ol style="list-style-type: decimal">
                                @for (descInfo of desc.description; track $index) {
                                  <li class="pt-2">
                                    {{ descInfo }}
                                  </li>
                                }
                              </ol>
                            }
                          </a>
                        }

                        @if (psgr.name === "Fare Rules") {
                          <p class="fare-word">
                            @if (desc?.description?.length) {
                              <ol style="list-style-type: decimal">
                                @for (descInfo of desc.description; track $index) {
                                  <li class="pt-2">
                                    {{ descInfo }}
                                  </li>
                                }
                              </ol>
                            }
                          </p>
                        }

                        @if (psgr.name === "Supported Features") {
                          <ol style="list-style-type: decimal">
                            @for (descInfo of desc.description; track $index) {
                              <li class="pt-2">
                                {{ descInfo }}
                              </li>
                            }
                          </ol>
                        }
                      </td>
                    </tr>
                  }
                </table>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
